import React from 'react';
import { Navigate } from 'react-router-dom';
import { toast } from 'react-toastify';
const CustomToast = ({ closeToast,msg }) => (
  <div>
    <p>{msg}</p>
    <button
      className="btn btn-primary btn-sm mt-1" style={{background:"#f8dce8",border:"#f8dce8",color:"#212121",fontSize:"12px"}}
      onClick={() => {
        document.getElementById("loginID")?.click();
        closeToast?.();
      }}
    >
      JETZT ANMELDEN
    </button>
  </div>
);
const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('log_in_data');
  if (token == null || token == "") {
    toast.dismiss();
    // toast.warning("Bitte einloggen zum Fortfahren!");
    toast.warning(<CustomToast msg={"Bitte einloggen zum Fortfahren!"} />);
  }

  return ((token == null || token == "") ? <Navigate to="/" /> : children);
};

export default PrivateRoute;